export enum EWalletPage {
  page_wallet_cash_in_landing = 'page_wallet_cash_in_landing',
  page_global_sheba_number = 'page_global_sheba_number',
  page_wallet_cach_out_landing = 'page_wallet_cach_out_landing',
  page_wallet_cach_out_process = 'page_wallet_cach_out_process',
  page_wallet_cach_out_receipt = 'page_wallet_cach_out_receipt',
  page_global_customer_birth_date = 'page_global_customer_birth_date',
  page_wallet_bnpl_receipt = 'page_wallet_bnpl_receipt',
  page_wallet_cash_in_terms = 'page_wallet_cash_in_terms',
  page_wallet_landing = 'page_wallet_landing',
  page_global_national_id = 'page_global_national_id',
  page_global_shahkar_exception = 'page_global_shahkar_exception',
  page_wallet_cash_in_cutoff_time = 'page_wallet_cash_in_cutoff_time',
}
